/**
 * The three fields of a time entry dialog - Start, End, Duration - are one
 * span read three ways, and they follow each other the way Toggl's do: a
 * moved start or end recalculates the duration, a typed duration moves the
 * end. Whole minutes, because that is what the dialogs read and save.
 */
const MINUTE = 60 * 1000;

export const minutesBetween = (start, end) => Math.max(0, Math.round((end.getTime() - start.getTime()) / MINUTE));

export const endFor = (start, minutes) => new Date(start.getTime() + Math.max(0, minutes || 0) * MINUTE);

/**
 * A start dragged past the end keeps the duration and carries the end along;
 * anything else leaves the end where it is and re-reads the duration.
 */
export const spanAfterStartChange = ({ start, end, minutes }) =>
    end && start < end ? { end, minutes: minutesBetween(start, end) } : { end: endFor(start, minutes), minutes };
